import React, { useState } from "react";
import { Box, Container, Typography, TextField } from "@mui/material";
import SlateEditor from "./SlateEditor";

const BlogEditor = () => {
  const [meta, setMeta] = useState({
    title: "",
    slug: "",
    description: "",
  });

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 6 }}>
        <Typography variant="h4" sx={{ mb: 3 }}>
          Blog Editor
        </Typography>

        {/* META INPUTS */}
        <TextField
          fullWidth
          label="Title"
          sx={{ mb: 2 }}
          value={meta.title}
          onChange={(e) =>
            setMeta({ ...meta, title: e.target.value })
          }
        />

        <TextField
          fullWidth
          label="Slug"
          sx={{ mb: 2 }}
          value={meta.slug}
          onChange={(e) =>
            setMeta({ ...meta, slug: e.target.value })
          }
        />

        <TextField
          fullWidth
          label="Description"
          sx={{ mb: 3 }}
          value={meta.description}
          onChange={(e) =>
            setMeta({ ...meta, description: e.target.value })
          }
        />

        {/* PASS META DOWN */}
        <SlateEditor meta={meta} />
      </Box>
    </Container>
  );
};

export default BlogEditor;
